export default {
  "path": "/demo/businessChancepoint",
  "meta": {
    "name": "demo-机会点组件 Demo",
    "title": "机会点组件 Demo",
    "isComponentDoc": true,
    "category": "Business"
  }
};